import React from 'react';
import { motion } from 'framer-motion';
import { Target, Lightbulb, LayoutList } from 'lucide-react';
export const ValueProps: React.FC = () => {
  return <section className="py-12 sm:py-16 bg-white px-4 sm:px-6 lg:px-8" data-id="element-196">
      <div className="max-w-7xl mx-auto" data-id="element-197">
        <div className="text-center mb-10 sm:mb-12" data-id="element-198">
          <h2 className="font-serif text-2xl sm:text-4xl font-bold text-navy mb-3" data-id="element-199">
            UN SISTEMA QUE TE AYUDA A DIFERENCIAR CADA CASO
          </h2>
          <p className="text-lg sm:text-xl text-accent font-semibold mb-6" data-id="element-200">
            Y ADAPTAR TU INTERVENCIÓN
          </p>
          <div className="max-w-3xl mx-auto text-gray-600 space-y-3 text-base sm:text-lg" data-id="element-201">
            <p className="font-semibold text-navy" data-id="element-202">
              Sistema Insomnio Clínico Adaptado™
            </p>
            <p data-id="element-203">
              Creamos un sistema claro y aplicable para que dejes de intervenir
              el insomnio como si todos los pacientes funcionaran igual.
            </p>
            <p data-id="element-204">
              Porque no es lo mismo trabajar con un paciente que no duerme
              porque su mente no se apaga, que con un paciente que se despierta
              sin energía, con ánimo bajo y sensación de día perdido.
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-3 gap-4 sm:gap-6 max-w-5xl mx-auto" data-id="element-205">
          <motion.div whileHover={{
          y: -5
        }} className="bg-offwhite p-5 rounded-xl shadow-sm border border-lavender-muted" data-id="element-206">
            <div className="w-10 h-10 bg-lavender rounded-full flex items-center justify-center mb-3" data-id="element-207">
              <Target className="w-5 h-5 text-navy" data-id="element-208" />
            </div>
            <h3 className="font-serif text-base sm:text-lg font-bold text-navy mb-2" data-id="element-209">
              MÁS PRECISIÓN CLÍNICA
            </h3>
            <p className="text-gray-600 text-sm leading-snug" data-id="element-210">
              Identificás si el insomnio está sostenido por preocupación,
              hiperactivación, fatiga emocional o pérdida de rutina.
            </p>
          </motion.div>

          <motion.div whileHover={{
          y: -5
        }} className="bg-offwhite p-5 rounded-xl shadow-sm border border-lavender-muted" data-id="element-211">
            <div className="w-10 h-10 bg-lavender rounded-full flex items-center justify-center mb-3" data-id="element-212">
              <Lightbulb className="w-5 h-5 text-navy" data-id="element-213" />
            </div>
            <h3 className="font-serif text-base sm:text-lg font-bold text-navy mb-2" data-id="element-214">
              MÁS CLARIDAD PARA INTERVENIR
            </h3>
            <p className="text-gray-600 text-sm leading-snug" data-id="element-215">
              Dejás de aplicar las mismas técnicas para todos y adaptás el
              abordaje según el cuadro clínico real.
            </p>
          </motion.div>

          <motion.div whileHover={{
          y: -5
        }} className="bg-offwhite p-5 rounded-xl shadow-sm border border-lavender-muted" data-id="element-216">
            <div className="w-10 h-10 bg-lavender rounded-full flex items-center justify-center mb-3" data-id="element-217">
              <LayoutList className="w-5 h-5 text-navy" data-id="element-218" />
            </div>
            <h3 className="font-serif text-base sm:text-lg font-bold text-navy mb-2" data-id="element-219">
              ESTRUCTURA REAL PARA SESIÓN
            </h3>
            <p className="text-gray-600 text-sm leading-snug" data-id="element-220">
              Protocolos, planes de sesión, reformulaciones y plantillas para
              trabajar ansiedad, depresión y perfiles mixtos.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
};